/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';


import Vue from 'vue'
import VueRouter from 'vue-router'

import './plugins/base'
import './plugins/chartist'
import vuetify from './plugins/vuetify'
import PortalVue from 'portal-vue'

import guestRoutes from "./routes/guest"
import routes from "./routes/app"
import store from './store'




Vue.use(PortalVue);
Vue.use(VueRouter);

// import './plugins/vee-validate'
function init() {

    if (document.getElementById("guest")){
        new Vue({
            el: '#guest',
            vuetify,
            router:new VueRouter({
                mode: 'history',
                routes:guestRoutes,
            })
        });
    }else{
        axios.defaults.baseURL = '/service/web/';

        new Vue({
            el: '#app',
            vuetify,
            store,
            router:new VueRouter({
                mode: 'history',
                routes:routes,
            }),
            components: {
                MainDrawer: () => import('./components/drawers/MainDrawer'),
            },
            data : () => ({
                dark:true,
            }),
            created () {
                this.$vuetify.theme.dark = false;
                axios.interceptors.response.use((response) =>{ return response; }, (error) =>{
                    console.log("Intercepted");
                    if (error.response) {
                        switch (error.response.status) {
                            case 401:
                                location.href = "/login";
                                break;
                            default:
                                console.log("Unhandled response status: ",error.response.status);
                                break;
                        }
                    } else if (error.request) {
                        /*
                         * The request was made but no response was received, `error.request`
                         * is an instance of XMLHttpRequest in the browser and an instance
                         * of http.ClientRequest in Node.js
                         */
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request and triggered an Error
                        console.log('Error', error.message);
                    }
                    return Promise.reject(error);
                });
            },
            beforeDestroy () {
                this.$vuetify.theme.dark = false
            },
        });
    }

}

if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(init, 1);
} else {
    document.addEventListener("DOMContentLoaded", init);
}
